import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { EventsMutationKeys } from '../../../keys'
import { deleteEvent } from '../../services'

interface DeleteEventParams {
	id: string
}

export default function useMutationDeleteEvent(
	props?: UseBaseMutationOptions<void, DeleteEventParams>,
) {
	return useMutation({
		mutationKey: [EventsMutationKeys.deleteEvent],
		mutationFn: (params) => deleteEvent(params.id),
		...props,
	})
}
